<section class="caa-card" *ngIf="hasAnyAction">
  <h2 class="caa-card__title">Actions</h2>

  <div class="caa-actions">

    <!-- Submit for verification -->
    <button
      *ngIf="canSubmit"
      class="caa-btn caa-btn--primary"
      type="button"
      (click)="submitForVerification.emit()"
    >
      Submit for verification
    </button>

    <!-- Retry compliance validation -->
    <button
      *ngIf="canRetryCompliance"
      class="caa-btn caa-btn--primary"
      type="button"
      (click)="retryComplianceValidation.emit()"
    >
      Retry compliance validation
    </button>

    <!-- Verify -->
    <button
      *ngIf="canVerify"
      class="caa-btn caa-btn--primary"
      type="button"
      (click)="verify.emit()"
    >
      Verify
    </button>

    <!-- Force verification -->
    <button
      *ngIf="canForceVerification"
      class="caa-btn caa-btn--primary"
      type="button"
      (click)="forceVerification.emit()"
    >
      Force verification
    </button>

    <!-- Force financial validation -->
    <button
      *ngIf="canForceFinancialValidation"
      class="caa-btn caa-btn--primary"
      type="button"
      (click)="forceFinancialValidation.emit()"
    >
      Force financial validation
    </button>

    <!-- Return to KAM -->
    <button
      *ngIf="canReturnToKam"
      class="caa-btn caa-btn--danger"
      type="button"
      (click)="returnToKam.emit()"
    >
      Return to KAM
    </button>

  </div>
</section>
